// useAuth hook, kept in its own module so AuthContext.tsx exports only a component.

import { useContext } from "react";

import { AuthContext, type AuthState } from "./auth-context";

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (ctx === null) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return ctx;
}
